import axios from "axios";

export default class UsuariosService {
  allEspecialistas() {
    return axios.get(process.env.VUE_APP_API_PUBLIC + "usuarios/medicos");
  }
  allEspecialidadesDeUnMedico(id) {
    return axios.get(process.env.VUE_APP_API_PUBLIC + "usuarios/medicos/"+id);
  }
  allUsuarios() {
    return axios.get(process.env.VUE_APP_API_PUBLIC + "usuarios/todos");
  }
  enviarCorreo(data) {
    return axios.post(process.env.VUE_APP_API_PUBLIC + "usuarios/correo", data);
  }
  enviarCorreoAEspecialista(data) {
    return axios.post(process.env.VUE_APP_API_PUBLIC + "usuarios/especialistas/correo", data);
  }
  crearUsuario(data) {
    return axios.post(process.env.VUE_APP_API_PUBLIC + "usuarios/create", data);
  }
  editarUsuario(data) {
    return axios.put(process.env.VUE_APP_API_PUBLIC + "usuarios/update", data);
  }
  eliminarUsuario(data) {
    return axios.delete(process.env.VUE_APP_API_PUBLIC + "usuarios/delete", {
      data: data,
    });
  }
  subirAvatar(data) {
    return axios.post(
      process.env.VUE_APP_API_PUBLIC + "usuarios/avatar/create",
      data
    );
  }
  eliminarAvatar(data) {
    return axios.delete(
      process.env.VUE_APP_API_PUBLIC + "usuarios/avatar/delete",
      { data: data }
    );
  }
  toggleEnListado(data) {
    return axios.put(
      process.env.VUE_APP_API_PUBLIC + "usuarios/toggle",
      data
    );
  }
}
